import React, { useEffect, useState } from 'react'
import { Table } from '@scuf/common'
import baseServices from '../../../services/base.services'

const ResumenSumatoriaDomo2 = () => {

    const [state, setState] = useState(null)

    let headerTable = ['Mineral', 'Porcentaje', 'Masa']

    useEffect(() => {
        const getTTeg = async () => {
            let arrayValor = []
            try {
                var response = await baseServices.getTostacionModeloDomo({})
                if (response.data && response.data.length > 0) {
                    response.data.filter(n => n.Mineral === 'PIRITA' || n.Mineral === 'ENARGITA' || n.Mineral === 'TENANTITA').forEach((x, i) => {
                        arrayValor.push(x)
                    })

                    setState(arrayValor)
                }
            }
            catch (e) {
                console.log(e)
                getTTeg()
            }
        }
        getTTeg()
    }, [])

    return (
        <>
            {
                state &&
                <>
                    <h5>Detalle Compuestos Reactivos</h5>
                    <Table className='mb-4'>
                        <Table.Header>
                            {headerTable.map(x => <Table.HeaderCell content={x} />)}
                        </Table.Header>
                        <Table.Body>
                            {
                                state.map((x, i) =>
                                    <Table.Row>
                                        <Table.Cell>
                                            {x.Mineral}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {x.Porcentaje} %
                                        </Table.Cell>
                                        <Table.Cell>
                                            {x.Masa} Ton
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            }
                        </Table.Body>

                    </Table>

                    <h5>Sumatoria Compuestos Reactivos</h5>
                    <Table>
                        <Table.Header>
                            {headerTable.map(x => <Table.HeaderCell content={x} />)}
                        </Table.Header>
                        <Table.Body>
                            {
                                <Table.Row>
                                    <Table.Cell>
                                        {state[0].Mineral + state[1].Mineral + state[2].Mineral}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {state[0].Porcentaje + state[1].Porcentaje + state[2].Porcentaje}%
                                    </Table.Cell>
                                    <Table.Cell>
                                        {state[0].Masa + state[1].Masa + state[2].Masa} Ton
                                    </Table.Cell>
                                </Table.Row>
                            }
                        </Table.Body>
                    </Table>
                </>
            }
        </>
    )

}

export default ResumenSumatoriaDomo2
